if (!customElements.get("frigg-cart-recommendations")) {
  customElements.define(
    "frigg-cart-recommendations",
    class FriggCartRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === "true" || !this.dataset.url) return;
        this.load(this.dataset.url, true);
      }

      async load(url, allowFallback) {
        this.dataset.loaded = "true";
        try {
          const response = await fetch(url, {
            headers: { Accept: "text/html" },
          });
          if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);
          const documentFragment = new DOMParser().parseFromString(
            await response.text(),
            "text/html",
          );
          const source = documentFragment.querySelector(
            "[data-frigg-cart-recommendations-content]",
          );
          const destination = this.querySelector(
            "[data-frigg-cart-recommendations-content]",
          );
          if (source?.querySelector("li") && destination) {
            destination.replaceWith(source);
          } else if (allowFallback && this.dataset.fallbackUrl) {
            await this.load(this.dataset.fallbackUrl, false);
          }
        } catch (error) {
          console.warn("Cart recommendations could not be loaded.", error);
        }
      }
    },
  );
}
